<template>
  <div>
    <el-dialog
      title="入库"
      :visible.sync="show"
      class="top-draft-dialog put-storage"
      width="800px"
      :before-close="handleClose">
      <div class="card">
        <div class="row mb-3">
          <div class="col-lg-5 clearfix tags-dialog-left">
            <span class="title">添加标签</span>
            <b-form-input v-model="pageParams.name" @keyup.enter.native="getList()" type="text" placeholder="标签名称"></b-form-input>
            <div class="tag-list">              
              <b-form-checkbox
              v-for="item in items" :key="item.id"
              v-model="selectTabs" 
              :value="item" 
              checked
              plain
              >{{ item.name }}</b-form-checkbox>
            </div>
          </div>
          <div class="col-lg-7 clearfix tags-dialog-right">
            <span class="title">已选定标签</span>
            <div class="select-tabs">
              <div 
                v-for="item in selectTabs" :key="item.id" 
                role="alert" 
                aria-live="polite" 
                aria-atomic="true" 
                class="pull-left alert alert-primary m-r-20"
              >
                {{ item.name }}
                <span @click="removeTabs(item)" >
                  <i class="bx bx-x font-size-16 align-middle"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!isBatch">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label>评论内容</label>
                <textarea 
                  placeholder="评论内容" 
                  class="form-control" 
                  v-model="currentItem.message"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label>附件</label>
                <div class="annex-list">
                  <div class="annex-item" v-for="data in currentItem.attachmentDtoList" :key="data.id">
                    <div class="video-url-min">
                      <video v-if="data.type != 'image'" controls="controls" :src="data.url"></video>
                      <img v-if="data.type == 'image'" :src="data.image" alt="">
                    </div>
                    <span @click="removeAnnexs(data)">删除</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button @click="handleClose()" class="btn btn-sm btn-outline-dark" type="button">取消</button>
              <button @click="submitCreate()" class="btn btn-sm btn-primary" type="button">确定</button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Vue from "vue";
import Swal from "sweetalert2";
import tags from '@/server/api/tags'
import content from '@/server/api/comments'


export default {
  components: {},

  data() {
    return {
      pageParams: {
        page: 1,
        pageSize: 999,
        name: ''
      },
      isBatch: false,
      currentItem: {},
      selectTabs: [],
      showState: '',
      items: [],
      show: false,
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel(item, isBatch){
      if(isBatch){
        this.isBatch = true
      } else {
         this.isBatch = false
      }
      this.currentItem = item
      this.selectTabs = []
      this.resetParams()
      this.show = true
    },

    handleClose(){
      this.show = false
    },

    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams)
      tags.list(params).then(resp => {
        if (resp.data) {
          if(resp.data.items){
            this.items = resp.data.items
          }
        }
      })
    },

    removeTabs(item){
      this.selectTabs.splice(this.selectTabs.indexOf(item), 1);
    },

    submitCreate(){
      let current = {
        code: 'storage'
      }
      let params = {}
      params.ids = []
      params.tagId = []
      this.selectTabs.forEach( function(item) {
        params.tagId.push(item.id)
      });
      params.tagId = params.tagId.toString()
      if(this.isBatch){
        params.ids = this.currentItem
      } else {
        params.ids.push(this.currentItem.id)
        params.message = this.currentItem.message
        params.attachmentDtoList = this.currentItem.attachmentDtoList
      }
      content.toStorage(params).then(resp => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: "入库成功！",
            showConfirmButton: false,
            timer: 1000
          });
          this.handleClose()
          this.$emit('pageCallback', current)
        } else {
          Vue.swal(resp.msg);
        }
      })
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.name = ''
      this.getList()
    },

    removeAnnexs(data){
      this.currentItem.attachmentDtoList.splice(this.currentItem.attachmentDtoList.indexOf(data), 1);
    },

  }

};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.annex-item {
  width: 170px;
}

.annex-item span {
  left: 127px;
}

.video-url-min {
  width: 120px;
  height: 150px;
}
</style>

